

import i18next from 'i18next';

export const Months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const monthsGenitiveRu = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря"
]

export const MonthsRU = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];

export function getMonthsLabValues() {
    if (i18next.language === 'ru') return MonthsRU.map((value, index) => ({ label: value, value: index + 1 }));
    return Months.map((value, index) => ({ label: value, value: index + 1 }));
}


import i18next from 'i18next';

export const Months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const monthsGenitiveRu = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря"
]

export const MonthsRU = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];

export function getMonthsLabValues() {
    if (i18next.language === 'ru') return MonthsRU.map((value, index) => ({ label: value, value: index + 1 }));
    return Months.map((value, index) => ({ label: value, value: index + 1 }));
}
